import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AuditHelperFunctions } from 'src/app/helpers/audit-helper-functions';
import { AuditMerchantViewModel } from 'src/app/models/audit-merchant-view-model';
import { AuditService } from 'src/app/services/audit.service';

@Component({
  selector: 'app-audit-merchant-details',
  templateUrl: './audit-merchant-details.component.html',
  styleUrls: ['./audit-merchant-details.component.scss']
})
export class AuditMerchantDetailsComponent implements OnInit {
  @Input() merchantNumber: string;

  public dtOptions: DataTables.Settings;
  public dtTrigger: Subject<boolean> = new Subject();
  public merchantDetails: AuditMerchantViewModel[] = [];

  private auditHelperFunctions: AuditHelperFunctions;

  @ViewChild(DataTableDirective)
  public dtElement: DataTableDirective;
  dtInstance: Promise<DataTables.Api>;

  constructor(private _auditService: AuditService) {
    this.auditHelperFunctions = new AuditHelperFunctions();
  }

  async ngOnInit(): Promise<void> {
    this.dtOptions = {
      order: [''],
      pageLength: 10,
      pagingType: 'full_numbers'
    };
    this.merchantDetails = await this._auditService.GetMerchantDetails(this.merchantNumber);
    this.dtTrigger.next();
  }

  public DownloadCsv(): void {
    this.auditHelperFunctions.DownloadCsv(this.merchantDetails, 'Merchant_Audit_Trail_');
  }

  public print(): void {
    this.auditHelperFunctions.print();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
